const header = document.querySelector('.main-header'),
	menu = document.querySelector('.main-header__menu'),
	headerOverlay = document.querySelectorAll('.main-header__overlay'),
	breakpoint = window.matchMedia('(min-width: 1025px)'),
	hamburger = document.querySelector('.hamburger');



let run = false;

const initCarousel = () => {
	const wrappers = document.querySelectorAll('.main-header__carousel');

	let id;

	const runMarquee = (selector) => {
		const element = selector;
		const clone = element.innerHTML;
		const firstElement = element.children[0];
		let i = 0;

		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);
		element.insertAdjacentHTML('beforeend', clone);

		id = setInterval(() => {
			firstElement.style.marginLeft = `-${i}px`;

			if (i > firstElement.offsetWidth) i = 0;

			i = i + parseFloat(0.1);
		}, 0);
	}

	const destroyMarquee = (selector) => {
		clearInterval(id);

		const element = selector,
			firstElement = element.children[0],
			elements = element.querySelectorAll('.main-header__carousel-heading');

		firstElement.style.marginLeft = 0;

		for (let i = 1; i < elements.length; i++) {
			elements[i].remove();
		}
	}

	const breakpointChecker = () => {

		if (wrappers) {
			if (breakpoint.matches === true && run == false) {
				wrappers.forEach(wrapper => {
					destroyMarquee(wrapper);
				})
			} else {
				wrappers.forEach(wrapper => {
					destroyMarquee(wrapper);
					runMarquee(wrapper);
				})
			}
		}
	};

	breakpoint.addEventListener("change", breakpointChecker);
	breakpointChecker();
}

const menuSpoilers = () => {
	const menuTitle = menu.querySelectorAll('.mega-menu__item--accordion .mega-menu__item-title');

	if (menuTitle) {
		menuTitle.forEach(item => {
			item.addEventListener('click', (e) => {
				item.classList.toggle('active');
				item.parentElement.classList.toggle('is-open');
			});
		});
	}
}

const initSearch = () => {
	const searchTrigger = document.querySelector('.main-header__actions-search'),
		searchForm = document.querySelector('.search-form'),
		searchFormInput = document.querySelector('.search-form__input');

	const openSearchForm = () => {
		searchForm.classList.add('active');
		searchFormInput.focus();

		const val = searchFormInput.value;
		searchFormInput.value = '';
		searchFormInput.value = val;

		headerOverlay.forEach(overlay => {
			if (overlay.classList.contains('is_search')) {
				overlay.classList.add('active');
			}
		});
	};

	const closeSearchForm = () => {
		searchForm.classList.remove('active');
		searchFormInput.blur();

		headerOverlay.forEach(overlay => {
			if (overlay.classList.contains('is_search')) {
				overlay.classList.remove('active');
			}
		});
	}

	searchTrigger.addEventListener('click', openSearchForm);
	hamburger.addEventListener('click', closeSearchForm);


	headerOverlay.forEach(overlay => {
		overlay.addEventListener('click', () => {
			if (overlay.classList.contains('is_search')) {
				closeSearchForm();
			}
		});
	});
};

const initMenu = () => {
	const openMenu = () => {
		menu.classList.add('open');
		header.classList.add('is_menu_overlay');
		document.body.classList.add('overflow-hidden');

		headerOverlay.forEach(overlay => {

			if (overlay.classList.contains('is_menu')) {
				overlay.classList.add('active');
			}

		});
	};

	const closeMenu = () => {
		menu.classList.remove('open');
		header.classList.remove('is_menu_overlay');
		document.body.classList.remove('overflow-hidden');

		headerOverlay.forEach(overlay => {
			if (overlay.classList.contains('is_menu')) {
				overlay.classList.remove('active');
			}
		});
		let languageSelectedElemToClose = document.getElementById("language_selected_header");
		if (languageSelectedElemToClose && languageSelectedElemToClose.parentElement && languageSelectedElemToClose.parentElement.getElementsByTagName('ul') && languageSelectedElemToClose.parentElement.getElementsByTagName('li')) {

			languageSelectedElemToClose.parentElement.getElementsByTagName('ul')[0].style.display = "none";
			languageSelectedElemToClose.parentElement.getElementsByTagName('ul')[0].style.opacity = "0"
			Array.from(languageSelectedElemToClose.parentElement.getElementsByTagName('li')).forEach((e) => { e.style.display = "none"; e.style.opacity = "0"; })
			languageSelectedElemToClose.setAttribute('opened', false)
		}

	};

	hamburger.addEventListener('click', openMenu);

	headerOverlay.forEach(overlay => {
		overlay.addEventListener('click', () => {
			if (overlay.classList.contains('is_menu')) {
				closeMenu();
			}
		});

	});


	const breakpointChecker = () => {
		console.log("breakpointChecker")
		if (breakpoint.matches === true) {
			closeMenu();
		}
	};

	breakpoint.addEventListener("change", breakpointChecker);
	breakpointChecker();
};

const initMegaMenu = () => {
	const categoryItem = document.querySelector('.main-header__menu-item.is-category');

	const hoverEffectActive = () => {
		headerOverlay.forEach(overlay => {
			if (overlay.classList.contains('is_menu')) {
				overlay.classList.add('active');
			}
		});
	};

	const hoverEffectDisable = () => {
		headerOverlay.forEach(overlay => {
			if (overlay.classList.contains('is_menu')) {
				overlay.classList.remove('active');
			}
		});
	}

	if (categoryItem) {
		const breakpointChecker = () => {
			if (breakpoint.matches === true) {
				categoryItem.addEventListener('mouseover', hoverEffectActive);
				categoryItem.addEventListener('mouseout', hoverEffectDisable);
			} else {
				hoverEffectDisable();

				categoryItem.removeEventListener('mouseover', hoverEffectActive);
				categoryItem.removeEventListener('mouseout', hoverEffectDisable);
			}
		};


		breakpoint.addEventListener("change", breakpointChecker);
		breakpointChecker();
	}
};

document.addEventListener('DOMContentLoaded', () => {
	initSearch();
	menuSpoilers();
	initMenu();
	initMegaMenu();

	setTimeout(() => {
		const element_width = window.getComputedStyle(document.getElementsByClassName('main-header__carousel-heading')[0]).width.replace("px", '');
		const wrap_width = document.getElementsByClassName('main-header__carousel')[0].clientWidth;

		if (element_width > wrap_width) {

			run = true;
			var overwritingStyleElem = document.head.appendChild(document.createElement("style"));

			overwritingStyleElem.innerHTML = `.main-header__carousel-heading:after {
			display: block !important;
			content: '';
			min-width: 4px;
			height: 4px;
			border-radius: 50%;
			background: var(--color-white);
			margin: 0 6px;}`;

		} else {

			run = false;

		}
		initCarousel();

	}, 1000)


})



